import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import ru from "./locales/ru.json";
import de from "./locales/de.json";
import zh from "./locales/zh.json";
import ko from "./locales/ko.json";
import tr from "./locales/tr.json";
import pt from "./locales/pt.json";
import jp from "./locales/jp.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      ru: { translation: ru },
      de: { translation: de },
      zh: { translation: zh },
      ko: { translation: ko },
      tr: { translation: tr },
      pt: { translation: pt },
      jp: { translation: jp },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "es", "ru", "de", "zh", "ko", "tr", "pt", "jp"],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
